import { Amplify, Auth } from 'aws-amplify';
import config from '../config';

Amplify.configure({
    Auth: {
        mandatorySignIn: true,
        region: config.cognito.REGION,
        userPoolId: config.cognito.USER_POOL_ID,
        userPoolWebClientId: config.cognito.APP_CLIENT_ID,
        redirectSignIn: config.cognito.REDIRECT_URI,
        redirectSignOut: config.cognito.SIGNOUT_URL,
    },
});

Auth.configure({
    oauth: {
        domain: config.cognito.DOMAIN,
        redirectSignIn: config.cognito.REDIRECT_URI,
        redirectSignOut: config.cognito.SIGNOUT_URL,
        responseType: 'token',
    },
});
